import { useEffect } from 'react';
import { EcommerceObject, trackEvent } from '@/lib/analytics';
import { ServerProduct } from '@/lib/janitsjar/Product';
import { useStores } from '@/components/store';
import { useParams } from 'next/navigation';

type ViewTrackerProps = {
  product: ServerProduct;
};

export function ViewTracker({ product }: ViewTrackerProps) {
  const params = useParams();
  const { current: currentStoreQuery } = useStores();

  const storeIsFetched = currentStoreQuery.isFetched;
  const currentStore = currentStoreQuery.data?.store;

  const slugs = (params?.slugs as string[]) ?? [];
  const path = slugs.join('/');

  useEffect(() => {
    const ecommerceObject: EcommerceObject = {
      value: product.price.amount || undefined,
      currency: 'NOK',
      items: [
        {
          item_id: product.sku,
          price: product.price.amount || undefined,
          quantity: 1,
        },
      ],
    };
    if (!ecommerceObject || !path || !storeIsFetched) return;
    trackEvent('view_item', ecommerceObject, currentStore || undefined);
    // We need to track only when the path changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, storeIsFetched]);

  return null;
}
